import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrThickArrowUpIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.6582 11.6653C14.2026 12.1116 13.4638 12.1116 13.0082 11.6652L8.00031 6.75915L2.99173 11.6653C2.53609 12.1116 1.79736 12.1116 1.34173 11.6653C0.886092 11.219 0.886092 10.4953 1.34173 10.049L7.17536 4.33473C7.39418 4.1204 7.69095 3.99999 8.0004 4C8.30985 4.00001 8.60662 4.12044 8.82542 4.33479L14.6583 10.0491C15.1139 10.4954 15.1139 11.219 14.6582 11.6653Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrThickArrowUpIconComponent;
